module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "kp-select-open mobile-hide",
    attrs: {
      "to": {
        name: 'boxEdit',
        params: {
          locale: _vm.i18n.locale,
          boxId: _vm.box.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "icon-kp-edit"
  }), _vm._v(_vm._s(_vm.$t('general.actions.edit')) + "\n")])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-a9b72a6a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/list/item/ButtonEdit.vue
 ** module id = 899
 ** module chunks = 1
 **/